/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
    bool, string, shape, func,
} from 'prop-types';
import { Button, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import withValidation from '../../../../pages/Checkout/containers/CheckoutFloral/Partials/TextFieldWrapper/ValidationHOC';
import bgsOrderRequestAPI from '../../../../../apis/email-apis/bgsOrderRequest';
import { getAccessToken } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getDataDictionary } from '../../../../../state/ducks/App/App-Selectors';
import FieldsData from './Forms/input-fields.json';
import InputField from './types/InputField';
import { getClientDate } from '../../../Chatbot/static_data/utils/dateUtils';

const initState = {
    firstName: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    lastName: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    email: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    phone: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    desiredProduct: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    quantity: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    date: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    message: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
};

const BGSContactForm = (props) => {
    const [formState, setFormState] = useState({
        firstName: '', lastName: '', email: '', phone: '', desiredProduct: '', quantity: '', shippingAddress: 'no_delivery', date: null, message: '', emailResponse: { message: '', statusCode: 200 },
    });

    const { isValid } = props;

    const scollToRef = useRef();

    useEffect(() => {
        const clientDate = getClientDate();
        setFormState((prevState) => ({ ...prevState, date: clientDate }));
    }, []);

    const jwt = useSelector(getAccessToken);
    const dataDictionary = useSelector(getDataDictionary);

    const handleFieldChange = (e) => {
        const fieldName = e?.target?.name;
        const fieldValue = e?.target?.value;
        setFormState((prevState) => ({ ...prevState, [fieldName]: fieldValue }));
    };

    const handleFieldBlur = (key, response) => {
        const { handleOnBlur } = props;
        handleOnBlur(key, response, formState);
    };

    const resetForm = (emailResponse) => {
        if (emailResponse) {
            setFormState({
                firstName: '', lastName: '', email: '', phone: '', desiredProduct: '', quantity: 0, shippingAddress: false, date: new Date(), message: '', emailResponse,
            });
        } else {
            setFormState({
                firstName: '', lastName: '', email: '', phone: '', desiredProduct: '', quantity: 0, shippingAddress: false, date: new Date(), message: '', emailResponse: { message: '', statusCode: 200 },
            });
        }
    };

    const sendOrderRequest = async () => {
        if (!isValid) {
            scollToRef.current.scrollIntoView({ behavior: 'smooth' });
        }
        const {
            validateFormFieldsOnSubmit, formFieldState,
        } = props;

        const fieldsToValidate = ['firstName', 'lastName', 'email', 'quantity', 'desiredProduct'];
        validateFormFieldsOnSubmit(fieldsToValidate, formState, null, false);
        const {
            firstName, lastName, email, phone, desiredProduct, quantity, shippingAddress, date, message,
        } = formFieldState;
        if (!firstName?.flagError && !lastName?.flagError && !email?.flagError && !phone?.flagError && !desiredProduct?.flagError && !quantity?.flagError && !shippingAddress?.flagError && !date?.flagError && !message?.flagError) {
            const newDateOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            };
            const payload = {
                firstname: formState.firstName,
                lastname: formState.lastName,
                email: formState.email,
                phone: formState.phone,
                order_details: {
                    orderquantity: formState.quantity,
                    delivery_date: formState.date ? new Date(formState.date)?.toLocaleDateString?.('en-US', newDateOptions) : '',
                    message: formState.message,
                    desiredProduct: formState.desiredProduct,
                    stateDelivery: formState.shippingAddress,
                },
            };
            if (formState.phone !== '') {
                payload.phone = (formState.phone?.toString())?.replace(/\D/g, '');
            }
            const apiResponse = await bgsOrderRequestAPI(jwt, payload);

            if (apiResponse?.status !== 200) {
                setFormState((prevState) => ({ ...prevState, emailResponse: { message: 'There was an error sending the request. Please try again later.', statusCode: apiResponse?.data?.status || apiResponse?.status } }));
            } else {
                const emailResponse = { message: 'Your request was sent successfully.', statusCode: apiResponse?.status };
                resetForm(emailResponse);
            }
        }
    };

    const {
        formFieldState, getTextFieldProps,
    } = props;

    const fieldsComponents = [{ name: 'contact', title: 'Contact' }, { name: 'order', title: 'Order Details' }];

    return (
        <section id="bgs-contact-form" className="bgsContactForm">
            <Grid ref={scollToRef}>
                <h1>{dataDictionary?.['Get Started']?.toUpperCase() || 'GET STARTED'}</h1>
                <p className="subTitle">Please fill out the information below and we will be in touch.</p>
                {fieldsComponents.map(({ name, title }) => (
                    <div key={`FieldArray${title}${name}`}>
                        <div className="contactTitle">{title}</div>
                        <Grid container className={`${name}Article`}>
                            {FieldsData[name]?.map((fieldInfo) => (
                                <InputField
                                    key={fieldInfo.name}
                                    fieldInfo={fieldInfo}
                                    formFieldState={formFieldState}
                                    getTextFieldProps={getTextFieldProps}
                                    formState={formState}
                                    isPlants
                                    handleFieldChange={handleFieldChange}
                                    handleFieldBlur={handleFieldBlur}
                                />
                            ))}
                        </Grid>
                    </div>
                ))}
                <Button
                    id="btn-bgs-request"
                    className="sendOrderRequest"
                    variant="text"
                    onClick={sendOrderRequest}
                >
                    {dataDictionary?.['Sendd Order Request']?.toUpperCase() || 'SEND ORDER REQUEST'}
                </Button>
                {formState.emailResponse.message && (
                    <Grid item xs={12}>
                        <Alert severity={formState.emailResponse.statusCode !== 200 ? 'error' : 'success'}>
                            {dataDictionary?.[formState.emailResponse.message.replace(/\./g, '')] || formState.emailResponse.message}
                        </Alert>
                    </Grid>
                )}
            </Grid>
        </section>
    );
};

BGSContactForm.propTypes = {
    formFieldState: shape({
        firstName: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
        lastName: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
        email: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
        phone: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
        desiredProduct: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
        quantity: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
        date: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
        message: shape({
            required: bool,
            flagError: bool,
            errorMessage: string,
        }).isRequired,
    }).isRequired,
    validateFormFieldsOnSubmit: func.isRequired,
    handleOnBlur: func.isRequired,
    getTextFieldProps: func.isRequired,
    isValid: bool.isRequired,
};

const BGSContactFormValidation = withValidation(BGSContactForm, initState);

export default BGSContactFormValidation;
